<template>
  <v-tooltip top open-delay="1000">
    <template v-slot:activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
        class="d-inline-flex align-center text-no-wrap"
      >
        <v-icon :small="showLabel" :left="showLabel">
          <template v-if="visibility === CommentVisibility.Public">
            mdi-eye-outline
          </template>
          <template v-else-if="visibility === CommentVisibility.Restricted">
            mdi-eye-off-outline
          </template>
          <template v-else-if="visibility === CommentVisibility.Personal">
            mdi-lock-outline
          </template>
        </v-icon>
        <span v-if="showLabel">
          {{ $t(`comment.visibility.${visibility}`) }}
        </span>
      </span>
    </template>
    <span>
      <template v-if="visibility === CommentVisibility.Public">
        {{ $t("comment.help.visibilityPublic") }}
      </template>
      <template v-else-if="visibility === CommentVisibility.Restricted">
        {{ $t("comment.help.visibilityRestricted") }}
      </template>
      <template v-else-if="visibility === CommentVisibility.Personal">
        {{ $t("comment.help.visibilityPersonal") }}
      </template>
    </span>
  </v-tooltip>
</template>

<script lang="ts">
import { CommentVisibility } from "@/api/models/comment/type/comment-visibility.enum";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class CommentVisibilityIcon extends Vue {
  @Prop({ type: String, required: true })
  public readonly visibility!: CommentVisibility;

  // Quand true, affiche le libellé de visibilité à côté de l'icône (utilisé
  // dans le pied de page du commentaire). Sinon, icône seule (ex. sélecteur).
  @Prop({ type: Boolean, default: false })
  public readonly showLabel!: boolean;

  public CommentVisibility = CommentVisibility;
}
</script>
